import React, { Component } from 'react';

import { Table, Button, TableRow, TableHead, TableBody, TableCell, TextField, CardContent } from '@mui/material';

import ArrowLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowRightIcon from '@mui/icons-material/ChevronRight';
import ArrowTooltipCss from '../../../../../common/ArrowTooltipCss';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

import TrplSelect from '../../../../../common/TrplControls/TrplSelect';

import { trplFormEditColumnWidthes, trplFormEditColumnHeights } from '../../../../../constants';

import { getChainTitle } from '../../../../../utils';

class TableFormEditList extends Component {
  render() {
    const {
      group,
      classes,
      rowIndex,
      setupRbox,
      groupIndex,
      deleteGroup,
      groupsLength,
      formConcepts,
      toggleRstEditModal,
      onGroupFieldChange,
      changeGroupPosition,
      isPidsChainDuplicate,
      conceptRestrictionsIds,
      onGroupSizeSelectChange,
    } = this.props;

    const columnWidthes = trplFormEditColumnWidthes;
    const columnHeights = trplFormEditColumnHeights;

    return (
      <CardContent className={classes.groupContent}>
        <div className={classes.groupContentInner}>
          <div className={classes.column}>
            <div
              className={classes.column}
              style={{
                marginBottom: '5px',
              }}
            >
              <strong style={{ color: '#c4c4c4' }}>List</strong>
              <div className={`${classes.spaceBetweenStart}`}>
                <TextField
                  style={{
                    width: 'calc(100% - 80px)',
                  }}
                  label="Title"
                  placeholder="Title"
                  value={group.title}
                  className={classes.mr10}
                  onChange={(e) => onGroupFieldChange(rowIndex, groupIndex, 'title', e.target.value)}
                />

                <div className={`${classes.alignCenter} ${classes.mb10}`}>
                  <div className={classes.mr10}>
                    <TrplSelect
                      title="Width"
                      margin="none"
                      complicatedValues
                      values={columnWidthes}
                      value={group.width || 'auto'}
                      onChange={(e) => {
                        onGroupSizeSelectChange(rowIndex, groupIndex, 'width', e.target.value);
                      }}
                    />
                  </div>

                  <TrplSelect
                    title="Height"
                    margin="none"
                    complicatedValues
                    values={columnHeights}
                    value={group.height || '50vh'}
                    onChange={(e) => {
                      onGroupSizeSelectChange(rowIndex, groupIndex, 'height', e.target.value);
                    }}
                  />
                </div>
              </div>

              {group.items && group.items.length ? (
                <Table className={classes.mb5}>
                  <TableHead>
                    <TableRow style={{ height: 'auto' }}>
                      <TableCell style={{ padding: '2px' }}>Title</TableCell>

                      <TableCell style={{ padding: '2px' }}>Component</TableCell>

                      <TableCell style={{ padding: '2px' }}>Func</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {group.items.map((item, itemIndex) => {
                      const itemConceptKey = item.concept_key ? item.concept_key : 'concept';
                      const itemPid = Array.isArray(item.pid) ? +item.pid[0] : item.pid;

                      let isInConcept;
                      if ((item.type !== 'function' && item.type !== 'custom') && conceptRestrictionsIds[itemConceptKey]) {
                        isInConcept = conceptRestrictionsIds[itemConceptKey].has(+itemPid);
                      } else if (item.type === 'custom') {
                        isInConcept = item.concept_key !== formConcepts[itemConceptKey];
                      } else isInConcept = false;
                      
                      let componentTitle;

                      const pids = Array.isArray(item.pid) ? item.pid : [item.pid];

                      if (Object.values(formConcepts).length) {
                        for (const ancestor of Object.values(formConcepts)) {
                          if (!componentTitle) componentTitle = getChainTitle(pids, ancestor, setupRbox);
                        }
                      }

                      const isDuplicate = isPidsChainDuplicate(item.pid);

                      return (
                        <TableRow
                          className={`${isDuplicate && classes.mandatoryField}`}
                          style={{ height: 'auto' }}
                          key={itemIndex}
                        >
                          <TableCell style={{ padding: '2px 2px' }}>{item.title}</TableCell>

                          <TableCell
                            style={{
                              padding: '2px',
                              color: `${!isInConcept ? 'red' : ''}`,
                              fontStyle: `${item && item.inverted ? 'italic' : ''}`,
                            }}
                          >
                            {(item.type === 'predicate' || !item.type)
                            ? `${item.pid} ${componentTitle
                              ? componentTitle : item && item.title ? item.title : ''}`
                            : `${item.type}`}

                            {isDuplicate &&
                            <ArrowTooltipCss style={{verticalAlign: 'bottom'}} text={'This view already contains same predicate'}>
                              <ErrorIcon
                                style={{
                                  color: '#DD5900',
                                  marginLeft: '5px',
                                  fontSize: '16px',
                                }}
                              />
                            </ArrowTooltipCss>}
                          </TableCell>

                          <TableCell style={{ padding: '2px 2px' }}>
                            {item.type === 'function' ? item.func : null}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              ) : null}
            </div>
          </div>

          <div>
            <div className={`${classes.spaceBetween}`}>
              <Button
                style={{
                  alignSelf: 'flex-start',
                }}
                size="small"
                variant="contained"
                color="primary"
                onClick={() => {
                  toggleRstEditModal(rowIndex, groupIndex, 'list', true);
                }}
              >
                Edit
              </Button>

              <div className={classes.alignCenter}>
                {groupIndex !== 0 ? (
                  <ArrowLeftIcon
                    className={`${classes.mr10} ${classes.pointer}`}
                    onClick={() => {
                      changeGroupPosition(rowIndex, groupIndex, groupIndex - 1);
                    }}
                  />
                ) : null}

                {groupIndex !== groupsLength ? (
                  <ArrowRightIcon
                    className={`${classes.mr10} ${classes.pointer}`}
                    onClick={() => {
                      changeGroupPosition(rowIndex, groupIndex, groupIndex + 1);
                    }}
                  />
                ) : null}

                <Button
                  size="small"
                  color="secondary"
                  variant="contained"
                  onClick={() => deleteGroup(rowIndex, groupIndex)}
                >
                  Delete group
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    );
  }
}
export default (TableFormEditList);
